module.exports = __webpack_public_path__ + "assets/images/stopwatch.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/stopwatch.png
// module id = 1528
// module chunks = 1